// extracted by mini-css-extract-plugin
module.exports = {"tabTitle":"TabTitle_tabTitle__BQVQ6","tabTitle__link":"TabTitle_tabTitle__link__k8ljl","active":"TabTitle_active__VeALd"};